import { useLoaderData } from "react-router-dom";
import * as React from "react";

export async function loader(params) {
    if (!params) return {};
  
    const transactionInfo = await fetch(
      `https://smeshi-api.com/transactions/${params.transactionid}`
    ).then((response) => {
      if (!response.ok) {
        return {}
      }
  
      return response.json();
    });
  
    return { transactionInfo };
  }

export default function Transaction() {
    const { transactionInfo } = useLoaderData();
    return (
        <h1>transaction data goes here</h1>
    )
}